import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  SiteHeaderBar,
  SiteHeaderInner,
  SiteNav,
} from '../styles/policyStyles';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../context/LanguageContext';
import { BRAND_LOGO_SRC, LogoImage, LogoLink } from './BrandLogo';

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

function SiteHeader() {
  const { t } = useLanguage();

  const nav = [
    { label: t.nav.features, to: '/#events' },
    { label: t.nav.about, to: '/about' },
    { label: t.nav.support, to: '/support' },
    { label: t.footer.privacy, to: '/privacy' },
    { label: t.footer.terms, to: '/terms' },
  ];

  return (
    <SiteHeaderBar>
      <SiteHeaderInner>
        <LogoLink to="/" aria-label="omw home">
          <LogoImage src={BRAND_LOGO_SRC} alt="omw" $size={30} />
        </LogoLink>
        <HeaderActions>
          <SiteNav>
            {nav.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </SiteNav>
          <LanguageSwitcher compact />
        </HeaderActions>
      </SiteHeaderInner>
    </SiteHeaderBar>
  );
}

export default SiteHeader;
